import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { AdditionalLayout } from '../Layout';

// Y/N option set used by the three flag dropdowns on this tab.
const YES_NO_OPTIONS = [
    { id: 'Y', text: 'Yes' },
    { id: 'N', text: 'No' },
];

// Field names that present as a Yes/No select.
const YES_NO_FIELDS = ['DAMAGEFLAG', 'RECEIPTVERIFIED', 'SHIPMENTVERIFIED'];

function AditionalTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => AdditionalLayout, []);

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const handleAdditionalFormLoad = useCallback(() => {
        // setTimeout so formRefs are populated after the initial FormField render.
        setTimeout(() => {
            YES_NO_FIELDS.forEach((name) => loadLookupClient(name, YES_NO_OPTIONS));
        }, 100);
    }, [loadLookupClient]);

    // Re-apply the dropdown values when the underlying field state changes
    // (e.g. record loads via the GET after the tab mounts).
    useEffect(() => {
        YES_NO_FIELDS.forEach((name) => loadLookupClient(name, YES_NO_OPTIONS));
    }, [
        loadLookupClient,
        props.formFields?.DAMAGEFLAG,
        props.formFields?.RECEIPTVERIFIED,
        props.formFields?.SHIPMENTVERIFIED,
    ]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='E5F6A7B8-C9D0-1234-FABC-56789ABCDEF0'
                layoutName='WMSerialNumberCodesAdditionalForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleAdditionalFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(AditionalTab);
